@use '../../styling/typography.scss' as *;

.ChartErrorState {
  @extend %font-family-primary;

  display: flex;
  flex-direction: column;
  row-gap: 8px;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;

  .ErrorMessage {
    width: 100%;
    margin-top: 16px;
    text-align: left;
  }
}
